null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/typelevel/cats/v2.1.0/core/src/main/scala-2.12/cats/instances/package.scala